// extracted by mini-css-extract-plugin
export default {"container":"invalid-guest-link_container__CXOy5","titleContainer":"invalid-guest-link_titleContainer__0coPV","icon":"invalid-guest-link_icon__BJD+1"};